import React from 'react';

import {
  Row,
  Col,
  Button,
  Space,
  Alert,
  Table,
} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Filter from '../components/Filter';

import useList from '../../api/hooks/useList';

const ListView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loadConfig, setLoadConfig] = React.useState({
    pageIndex: 0,
    pageSize: 20,
    filter: {},
  });

  const {
    load,
    loading,
    data,
    error,
  } = useList('v1/users');

  React.useEffect(() => {
    load(loadConfig.pageIndex, loadConfig.pageSize, loadConfig.filter);
  }, [load, loadConfig]);

  const handleFilterChange = React.useCallback((newFilter) => {
    setLoadConfig({
      pageIndex: 0,
      pageSize: loadConfig.pageSize,
      filter: newFilter,
    });
  }, [setLoadConfig, loadConfig]);

  const renderError = () => (
    <Row style={{ height: '100%' }} justify="center" align="middle">
      <Col>
        <Alert message={JSON.stringify(error)} type="error" showIcon />
      </Col>
    </Row>
  );

  const handleTableChange = React.useCallback((page) => {
    setLoadConfig({
      ...loadConfig,
      pageIndex: page.current - 1,
      pageSize: page.pageSize,
    });
  }, [setLoadConfig, loadConfig]);

  if (error) {
    return renderError();
  }

  return (
    <Space size="large" style={{ width: '100%' }} direction="vertical">
      <Row justify="space-between">
        <Col>
          <h1>{t('users.pages.list.title')}</h1>
        </Col>
      </Row>
      <Row>
        <Col flex={1}>
          <Filter
            onSubmit={handleFilterChange}
            filter={loadConfig.filter}
          />
        </Col>
      </Row>
      <Row>
        <Col flex={1}>
          <Table
            loading={loading}
            dataSource={data ? data.list : []}
            rowKey={(record) => record.id}
            onChange={handleTableChange}
            pagination={{
              current: loadConfig.pageIndex + 1,
              pageSize: loadConfig.pageSize,
              total: data ? data.count : 0,
            }}
          >
            <Table.Column
              title={t('users.table.displayName')}
              dataIndex="displayName"
              key="displayName"
            />
            <Table.Column
              title={t('users.table.email')}
              dataIndex="email"
              key="email"
            />
            <Table.Colum
              title={t('users.table.actions')}
              key="action"
              render={(text, record) => (
                <Space size="middle">
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<EditOutlined />}
                    onClick={() => navigate(`/users/${record.id}`)}
                  />
                </Space>
              )}
            />
          </Table>
        </Col>
      </Row>
    </Space>
  );
};

export default ListView;
